import React, { useCallback } from 'react';
import InfiniteScroller from 'react-infinite-scroller';

import GameListSkeleton from './GameList/GameListSkeleton';

const defaultLoader = <GameListSkeleton />;

const InfiniteScroll = ({ children, getScrollParent, hasMore, isLoading, loadMore, loader }) => {
  const handleInfiniteLoad = useCallback(() => {
    if (!children || isLoading || !hasMore) {
      return;
    }

    loadMore();
  }, [children, isLoading, hasMore, loadMore]);

  return (
    <InfiniteScroller
      className="infinite-scroll-game-list"
      getScrollParent={getScrollParent}
      hasMore={hasMore && !isLoading}
      initialLoad={false}
      loadMore={handleInfiniteLoad}
      loader={loader || defaultLoader}
      threshold={0}
      useWindow={false}
    >
      {children}
    </InfiniteScroller>
  );
};

export default InfiniteScroll;
